import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}`;
